import { VideoSourceChoiceOption, VideoSourceFieldMetadata } from '../type/videoSourceType';

export const FASTVIEW_FEED_FORMAT = 'fastview';

/**
 * 서버 feed_format choices의 display_name은 한국어(예: "자동 감지 (도메인 기반)")다.
 * 값은 서버 choices를 그대로 쓰고, 화면 표기만 아래 영어 라벨로 덮는다.
 * 매핑에 없는 값은 서버 display_name을 그대로 보여준다.
 */
export const FEED_FORMAT_LABELS: Record<string, string> = {
  auto: 'Auto detect (auto)',
  fastview: 'Fastview Shorts (fastview)',
  zype: 'Zype (zype)',
  odk: 'ODK (odk)',
};

/**
 * feed_format / default_language 선택지는 서버 choices(OPTIONS)를 우선 사용한다.
 * 아래 목록은 OPTIONS가 막힌 환경에서만 쓰는 폴백이며, 백엔드 계보(main/staging)에
 * 따라 실제 허용값이 다르다. (staging: auto|fastview, main: auto|zype|odk)
 */
export const FEED_FORMAT_FALLBACK_OPTIONS: VideoSourceChoiceOption[] = Object.entries(
  FEED_FORMAT_LABELS
).map(([value, label]) => ({ value, label }));

/** 백엔드 LowerLanguage choices와 동일 (소문자 코드) */
export const DEFAULT_LANGUAGE_FALLBACK_OPTIONS: VideoSourceChoiceOption[] = [
  { value: 'ko', label: 'Korean (ko)' },
  { value: 'en', label: 'English (en)' },
  { value: 'zh', label: 'Chinese (zh)' },
  { value: 'zh-hans', label: 'Simple Chinese (zh-hans)' },
  { value: 'zh-hant', label: 'Traditional Chinese (zh-hant)' },
  { value: 'vi', label: 'Vietnamese (vi)' },
  { value: 'es', label: 'Spanish, Castilian (es)' },
  { value: 'ja', label: 'Japanese (ja)' },
];

export const FEED_FORMAT_AWARE_FIELDS = ['feed_format', 'default_season', 'default_language'];

/**
 * OPTIONS 실패 시 폴백: 필드를 감추면 운영자가 설정 자체를 못 하므로
 * "전부 지원한다"고 가정하고 노출한다. 미지원 필드는 서버가 무시한다.
 */
export const VIDEO_SOURCE_FIELD_METADATA_FALLBACK: VideoSourceFieldMetadata = {
  supportedFields: FEED_FORMAT_AWARE_FIELDS,
  feedFormatOptions: FEED_FORMAT_FALLBACK_OPTIONS,
  defaultLanguageOptions: DEFAULT_LANGUAGE_FALLBACK_OPTIONS,
  fromServer: false,
};
